const DISPATCH_GUARDS = 'Dispatch Guards'

export const DISPATCH_NO_AVAILABLE_GUARDS_ALERT_SHOWN = `${DISPATCH_GUARDS} - No Available Guards Alert Shown`
